document.addEventListener('DOMContentLoaded', function() {
  const widgetContainers = document.querySelectorAll('.custom-widget');
  if (!widgetContainers.length) return;

  widgetContainers.forEach(widget => {
    const sectionId = widget.getAttribute('data-section-id');
    const hiddenSellingPlan = widget.querySelector('input[name="selling_plan"]');

    // Function to update price (only change the price, no <del>)
    function updatePrice(price, forType) {
      const priceSpan = widget.querySelector(`.pricene[data-for="${forType}"]`);
      if (priceSpan) {
        priceSpan.innerHTML = price;
      }
    }

    // Function to show/hide price spans based on selected type
    function togglePriceVisibility(selectedType) {
      const priceSpans = widget.querySelectorAll('.pricene');
      priceSpans.forEach(span => {
        span.style.display = (span.dataset.for === selectedType) ? 'inline' : 'none';
      });
    }

    // Initially hide all price spans
    togglePriceVisibility('none'); // Or set to 'one' if default is one-time

    // Listen for radio changes
    const radios = widget.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        const subscriptionNotes = document.querySelector('[data-subscription-notes]');
        const subSelectContainer = widget.querySelector('[data-subscription-select]');
        const subSelect = subSelectContainer ? subSelectContainer.querySelector('select.selected-selling-plan-select') : null;
        let selectedType = '';

        if (radio.dataset.radioType === 'one_time_purchase') {
          if (subSelectContainer) subSelectContainer.style.display = 'none';
          if (subscriptionNotes) subscriptionNotes.style.display = 'none';
          hiddenSellingPlan.value = ''; // No plan for one-time
          updatePrice(radio.dataset.variantPrice, 'one');
          selectedType = 'one';
        } else if (radio.dataset.radioType === 'selling_plan_group') {
          if (subSelectContainer) subSelectContainer.style.display = 'grid';
          if (subscriptionNotes) subscriptionNotes.style.display = 'block';
          if (subSelect && subSelect.options.length > 0) {
            // Auto select first plan and update hidden
            const firstOption = subSelect.options[0];
            subSelect.value = firstOption.value;
            hiddenSellingPlan.value = firstOption.value;
            updatePrice(firstOption.dataset.price, 'sub');
            selectedType = 'sub';
          } else {
            hiddenSellingPlan.value = ''; // Reset if no options
          }
        }

        // Show the selected price span
        togglePriceVisibility(selectedType);
      });
    });

    // Listen for select changes
    const selects = widget.querySelectorAll('.selected-selling-plan-select');
    selects.forEach(select => {
      select.addEventListener('change', (e) => {
        hiddenSellingPlan.value = e.target.value;
        const selectedOption = e.target.options[e.target.selectedIndex];
        updatePrice(selectedOption.dataset.price, 'sub');
        togglePriceVisibility('sub'); // Ensure sub price is shown
      });
    });

    // Handle variant changes (assuming variant selector is select[name="id"] or input)
    const variantSelector = document.querySelector('select[name="id"]') || document.querySelector('input[name="id"]');
    if (variantSelector) {
      variantSelector.addEventListener('change', (e) => {
        const newVariantId = e.target.value;
        const sections = widget.querySelectorAll('.selling_plan_theme_integration');
        sections.forEach(sec => {
          sec.classList.toggle('selling_plan_theme_integration--hidden', sec.dataset.variantId !== newVariantId);
        });
        // Reset hidden and price based on new active section
        const activeRadio = widget.querySelector(`.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) input[type="radio"]:checked`);
        if (activeRadio) {
          activeRadio.dispatchEvent(new Event('change')); // Trigger update
        } else {
          hiddenSellingPlan.value = ''; // Reset if no radio checked
          togglePriceVisibility('none'); // Hide prices if no selection
        }
      });
    }

    // Initialize default (trigger change for checked radio in active section)
    const defaultRadio = widget.querySelector('.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) input[type="radio"]:checked');
    if (defaultRadio) {
      defaultRadio.dispatchEvent(new Event('change'));
    }
  });
});